// extracted by mini-css-extract-plugin
module.exports = {"layout":"TermsConditionsConfirmationPopup__layout--2Pr","innerContent":"TermsConditionsConfirmationPopup__innerContent--1TV","info":"TermsConditionsConfirmationPopup__info--367"};